import { useState } from "react";
import { toast } from "sonner";
import { PasswordInput } from "./PasswordInput";

export const SetPasswordModal = ({ onSubmit, title }) => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const handleSubmit = () => {
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    if (password !== confirm) return toast.error("Passwords don't match");
    onSubmit(password);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-3xl p-6 w-full max-w-md animate-scaleIn">
        <h2 className="text-xl font-bold mb-2">{title}</h2>
        <p className="text-slate-500 mb-6">Please set a new password to continue</p>
        <div className="space-y-3">
          <PasswordInput value={password} onChange={e => setPassword(e.target.value)} placeholder="New Password" testId="new-password" />
          <PasswordInput value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Confirm Password" testId="confirm-password" />
        </div>
        <button onClick={handleSubmit} className="w-full py-4 rounded-full bg-[#1e3a5f] text-white font-bold mt-6" data-testid="set-password-btn">Set Password</button>
      </div>
    </div>
  );
};
